import {
  checkPasswordReset,
  resetPassword,
} from '@jotta/grpc-connect-openapi/loginQuery'
import { useQuery, useMutation } from '@connectrpc/connect-query'

export function useCheckPasswordReset(resetKey?: string) {
  return useQuery(
    checkPasswordReset,
    { resetKey },
    { enabled: Boolean(resetKey) },
  )
}

export function useResetPasswordMutation() {
  return useMutation(resetPassword)
}
